// kendo
import { Pager } from '@progress/kendo-react-data-tools';
import { ListView } from '@progress/kendo-react-listview';
import { IntlProvider, LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
import { Button } from '@progress/kendo-react-buttons';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { filterBy } from "@progress/kendo-data-query";
// react
import { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
//css
import ElderInfoItem from './elderInfoItem';
import koMessage from '../../../com/ko-language.json';
import { getUserStatCnt } from '../../../service/monitor/allStatusService';
import { getUserListData } from '../../../service/log/elderLogService';
import { getUser, isAdmin } from '../../../service/authService';
loadMessages(koMessage, 'ko-KR');

const ElderInfoList = ({ conn, styles, map, elderInfoList, dongList, search, setSearch, getInfoData, initSearch, loadMap, history, defaultLati, defaultLongi}) => {

  // 카카오 적용
  const { kakao } = window;

  let locationState = useLocation().state;
  const [loading, setLoading] = useState(false);
  const [statCntList, setStatCntList] = useState({
    totalCnt: 0,
    normalCnt: 0,
    warnCnt: 0,
    offCnt: 0,
    dangerCnt: 0,
    firstBizCnt: 0,
  });
  // 유저 정보 리스트 데이터 소스
  const [userList, setUserList] = useState({
    all: [],
    filtered: [],
  });
  // 유저 드롭다운 박스
  const [user, setUser] = useState({ userTerm: '대상자 선택', userId: '' });
  const [dong, setDong] = useState({ dongTermSimple: '전체', dongCode: '' });

  let elements = document.getElementsByClassName('k-pager-sm');
  useEffect(() => {
    //그리드 페이징 가려지는거 처리
    if (elements.length) if (elements[0].classList.value.includes('k-pager-sm')) elements[0].classList.remove('k-pager-sm');
  }, [elements.length]);

  // 페이징 상태
  const [pager, setPager] = useState({
    skip: 0,
    take: 5,
  });

  // 페이징 이벤트
  const changePage = e => {
    setPager(pager => {
      const item = { ...pager };
      item.skip = e.skip;
      item.take = e.take;
      return item;
    });
  };
  // 유저 목록 불러오기
  const getUserList = () => {
    getUserListData(conn, search, getUserListCallback, getUserListRejection);
  };
  // 유저 목록 callback
  const getUserListCallback = result => {
    setUserList({ ...userList, all: result });
    moveInstaller(result);
    setData(result)
  };
  // 유저 목록 rejection
  const getUserListRejection = error => {};

  // 드롭다운 이벤트
  const onChangeEvt = e => {
    setSearch(search => {
      const item = { ...search };
      item.dongCode = e.target.value.dongCode;
      item.dong = e.target.value;
      item.lati = e.target.value.dongCode !== '' ? e.target.value.lati : item.rgnLati;
      item.longi = e.target.value.dongCode !== '' ? e.target.value.longi : item.rgnLongi;
      return item;
    });
  };

  // 설치자명 검색 이벤트
  const textInputEvt = e => {
    setSearch(search => {
      const item = { ...search };
      item.userTerm = e.target.value;
      return item;
    });
  };

  // 조회 이벤트
  const searchData = () => {
    let lati;
    let longi;
    let dongCode;
    dongList.find(data => {
      if (data.dongCode === search.dongCode) {    
        
        lati = data.lati;
        longi = data.longi
        dongCode = data.dongCode;

      }
    })
    if(lati || longi) {
      loadMap(lati, longi, dongCode);
    } else {
      loadMap(defaultLati, defaultLongi, '');
    }
    locationState = null;
    getStatCntList();
  };

  const [data, setData] = useState();

  const checkUserList = () => {
    if (userList.filtered.length) {
      return userList.filtered;
    } else if (isAdmin()) {
      if(dong.dongCode) {
        return userList.filtered;
      } else {
        return userList.all;
      }
    }
  };

  const filterData = (filter) => {
    const data = checkUserList();
    return filterBy(data, filter);
  }

  const filterChange = (e) => {
    setData(filterData(e.filter));
  };

  // 읍면동, 대상자 드롭다운 체인지 이벤트
  const changeDropEvt = e => {
    if (e.target.name === 'dong') {
      setUser({ userTerm: '대상자 선택', userId: '' });
      setSearch({ ...search, dongCode: e.target.value.dongCode, userId: '', userTerm: '' });
      // setDong(e.target.value);
      dong.dongCode = e.target.value.dongCode;
      dong.dongTermSimple = e.target.value.dongTermSimple;
      const filteredUserList = userList.all.filter(item => item.dongCode === e.target.value.dongCode);
      setUserList({ ...userList, filtered: filteredUserList });
      if(dong.dongCode) {
        setData(filteredUserList);
      } else {
        setData(userList.all);
      }
    } else if (e.target.name === 'user') {
      // setSearch({ ...search, userId: e.target.value.userId, userTerm: e.target.value.userTerm });
      if(e.target.value.userTerm === '대상자 선택') {
        setSearch({ ...search, userId: e.target.value.userId, userTerm: ''})
      } else {
        setSearch({ ...search, userId: e.target.value.userId, userTerm: e.target.value.userTerm });
      }
      setUser(e.target.value);
    }
  };

  //대상자 (정상, 경고, 위험, 미작동) 개수 조회
  const getStatCntList = () => {
    setLoading(true);
    if(locationState) {
      search.dongCode = locationState.dongCode;
    }
    getUserStatCnt(conn, search)
      .then(response => {
        const totalCnt = response.normalCnt + response.warnCnt + response.offCnt + response.dangerCnt;
        response.totalCnt = totalCnt;
        setStatCntList(response);
      })
      .catch(error => console.log('getStatCnt Error', error));
  };

  const statCntClickEvt = e => {
    initSearch();
    const { target } = e;
    if (target.id === 'normal') {
      search.meainStatCode = '20001';
    } else if (target.id === 'warn') {
      search.meainStatCode = '20002';
    } else if (target.id === 'danger') {
      search.meainStatCode = '20004';
    } else if (target.id === 'off') {
      search.meainStatCode = '20003';
    } else {
      search.meainStatCode = '';
    }
    setPager({ ...pager, skip: 0 });
    getInfoData(map);
  };

  const userDdlOpenEvt = () => {
    if (dongList.length) {
      if (getUser().userTypeCode === 2002) {
        const result = dongList.find(item => item.dongCode === getUser().dongCode);
        setDong(result);
        setSearch({ ...search, dongCode: getUser().dongCode });
        const filteredUserList = userList.all.filter(item => item.dongCode === getUser().dongCode);
        setUserList({ ...userList, filtered: filteredUserList });
      }
    }
  };

  const moveInstaller = (param) => {
    // 대시보드에서 지도 클릭시 데이터 셋팅
    if(locationState) {
      dongList.find(data => {
        if (data.dongCode === locationState.dongCode) {    
          search.dongCode = data.dongCode
          setDong(dataSource => {
            const item = { ...dataSource };
            item.dongCode = data.dongCode
            item.dongTermSimple = data.dongTermSimple
            return item;
          });

          let lati = data.lati;
          let longi = data.longi

          userList.all = param;

          setUser({ userTerm: '대상자 선택', userId: '' });
          setSearch({ ...search, dongCode: data.dongCode, userId: '', userTerm: '' });
          const filteredUserList = param.filter(item => item.dongCode === locationState.dongCode);
          
          setUserList(dataSource => {
            const item = { ...dataSource };
            item.filtered = filteredUserList
            return item;
          });

        } else {
        }
      });
      searchData();
    }
  }

  useEffect(() => {
    if (dongList.length) {
      if (getUser().userTypeCode === 2002) {
        const result = dongList.find(item => item.dongCode === getUser().dongCode);
        setDong(result);
        setSearch({ ...search, dongCode: getUser().dongCode });
        const filteredUserList = userList.all.filter(item => item.dongCode === getUser().dongCode);
        setUserList({ ...userList, filtered: filteredUserList });
        setData(filteredUserList);
      }
    }
  }, [dongList]);


  useEffect(() => {
    getUserList();
    getStatCntList();
  }, []);
  

  return (
    <span className="MapLeftBg">
      <div className="titleMap">
        <img src="/images/chncareweb/icon_marker.png" /> 대상자 검색
      </div>
      {/* 검색란 */}
      <div className={styles.SearchBoxB}>
        <span className={styles.searchSubTitle}>읍면동</span>
        <div className={['Searchdropdown', styles.Searchdropdown].join(' ')}>
          <DropDownList
            style={{ width: '130px' }}
            data={dongList}
            disabled={getUser().userTypeCode === 2002}
            defaultItem={{ dongTermSimple: '전체', dongCode: '' }}
            name="dong"
            textField="dongTermSimple"
            dataItemKey="dongCode"
            onChange={changeDropEvt}
            className="searchDong"
            value={dong}
          />
          <span className={styles.searchSubTitle}>대상자</span>
          <DropDownList
            style={{ width: '130px' }}
            data={data}
            defaultItem={{ userTerm: '대상자 선택', userId: '' }}
            name="user"
            textField="userTerm"
            dataItemKey="userId"
            onChange={changeDropEvt}
            // onOpen={userDdlOpenEvt}
            filterable={true}
            onFilterChange={filterChange}
            className="searchUser"
            value={user}
          />
        </div>
        {/* <input className={styles.searchTermMap} type="text" placeholder="대상자명" name="userTerm" onChange={textInputEvt} value={search.userTerm} /> */}
        <span className="searchSubTitleC">
          <Button className={styles.btnA} icon="search" name="inqBtn" onClick={searchData}>
            검색
          </Button>
        </span>
      </div>
      {/* 상태 현황판 */}
      <div className={styles.MapTbFourBG}>
        <table className={styles.MapTbFour}>
          <thead>
            <tr>
              <th onClick={statCntClickEvt} style={{ cursor: 'pointer' }}>
                총개소<span>({statCntList.totalCnt})</span>
              </th>
              <td colspan="3">
                <div
                  className="icon-BoXmap SetBoxBg"
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    initSearch();
                    search.bizType = '5001';
                    getInfoData(map);
                    getStatCntList();
                    pager.skip = 0;
                  }}>
                  <img className="almimg" src="/images/chncareweb/icon_set_23.png" alt="bell" />
                  <b>1차 설치제품 : {statCntList.firstBizCnt !== null ? statCntList.firstBizCnt : 0}</b>
                </div>
                <div
                  className="icon-BoXmap bellBoxBg"
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    initSearch();
                    search.dangerElderYn = 'Y';
                    getInfoData(map);
                    getStatCntList();
                    pager.skip = 0;
                  }}>
                  <img className="almimg" src="/images/chncareweb/icon_bell_23.png" alt="bell" />
                  <b>위험 대상자 : {statCntList.dangerElderCnt !== null ? statCntList.dangerElderCnt : 0}</b>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th className={styles.bgGreen} id="normal" onClick={statCntClickEvt}>
                정상
              </th>
              <th className={styles.bgOrg} id="warn" onClick={statCntClickEvt}>
                경고
              </th>
              <th className={styles.bgRed} id="danger" onClick={statCntClickEvt}>
                위험
              </th>
              <th className={styles.bgGry} id="off" onClick={statCntClickEvt}>
                미작동
              </th>
            </tr>
            <tr>
              <td>{statCntList.normalCnt}</td>
              <td>{statCntList.warnCnt}</td>
              <td>{statCntList.dangerCnt}</td>
              <td>{statCntList.offCnt}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className={styles.elderInfoList}>
        {elderInfoList.length !== 0 ? (
          <ListView
            // className={styles.installerMeainList}
            data={elderInfoList.slice(pager.skip, pager.take + pager.skip)}
            item={ElderInfoItem}
            map={map}
          />
        ) : (
          <span className="none-data">데이터가 존재하지 않습니다.</span>
        )}
      </div>

      <div className="uk-grid">
        <div className="uk-width-medium-1-1">
          <LocalizationProvider language="ko-KR">
            <IntlProvider locale="ko">
              <Pager
                skip={pager.skip}
                take={pager.take}
                total={elderInfoList.length}
                onPageChange={changePage}
                buttonCount={3}
                info={true}
                previousNext={true}
                type="numeric"
                className="installerPager"
              />
            </IntlProvider>
          </LocalizationProvider>
        </div>
      </div>
    </span>
  );
};

export default ElderInfoList;
